
namespace TabAurous.Production {
    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class SplittingDialog extends _Ext.TransDialog<SplittingRow, any> {

        protected getFormKey() { return SplittingForm.formKey; }
        protected getIdProperty() { return SplittingRow.idProperty; }
        protected getLocalTextPrefix() { return SplittingRow.localTextPrefix; }
        protected getNameProperty() { return SplittingRow.nameProperty; }
        protected getService() { return SplittingService.baseUrl; }
        protected getDeletePermission() { return SplittingRow.deletePermission; }
        protected getInsertPermission() { return SplittingRow.insertPermission; }
        protected getUpdatePermission() { return SplittingRow.updatePermission; }
        protected useViewMode() { return true; }
        public form = new SplittingForm(this.idPrefix);
        public Closing: boolean;
        bagselected: any;
        bomDetails: any[];
        splitEmptyBag: boolean;
        splitSingleItem: boolean;
        allowSplitParts: boolean;

        constructor() {
            super();
            var Config = Q.deepClone(q.DefualtEditorOptions);
            Config.height = 150;
            q.initItemEditor(this, this.form.Details, Config);
            //Make grid full width
            q.setTextRightAlign(this.form.Pieces);
            q.setTextRightAlign(this.form.Weight);
            q.setTextRightAlign(this.form.NoOfSubBag);
            q.setTextRightAlign(this.form.EachSubBagPieces);
            q.setTextRightAlign(this.form.EachSubBagParts);
            //q.hideEditorToolbar(this.form.Details);
            q.hideEditorLabel(this.form.Details);

            var fieldEditor: JQuery = this.form.BagNo.element.closest(".editor");
            fieldEditor.addClass("has-inplace-button");
            $(' <button type="button">...</button>')
                .addClass('inplace-button')
                .addClass('inplace-search edit')
                .attr('title', 'Search')
                .insertAfter(fieldEditor)
                .click((e) => { this.inplaceSearchClick(e) }
                );

            //var generateSubBag: JQuery = this.form.EachSubBagPieces.element.closest(".editor");
            //generateSubBag.addClass("has-button");
            //$(' <button type="button">Create Sub Bags</button>')
            //    .addClass('button')
            //    .attr('title', 'Search')
            //    .insertAfter(generateSubBag)
            //    .click((e) => { this.setSubBags() }
            //);
            //var generateSubBagParts: JQuery = this.form.EachSubBagParts.element.closest(".editor");
            //generateSubBagParts.addClass("has-button");
            //$(' <button type="button">Create Sub Bags</button>')
            //    .addClass('button')
            //    .attr('title', 'Search')
            //    .insertAfter(generateSubBagParts)
            //    .click((e) => { this.setSubBags() }
            //    );
            this.form.NoOfSubBag.changeSelect2(e => {
                if (this.form.Pieces.value != null) {

                    var pieces = this.form.Pieces.value;
                    var subbagnos = this.form.NoOfSubBag.value;
                    var parts = this.form.Parts.value;
                    var subbagspossible = pieces * parts;

                    if (pieces == 1) {
                        if (this.allowSplitParts) {
                            q.showAndEnableField(this.form.EachSubBagParts);
                            q.hideField(this.form.EachSubBagPieces);
                            if (subbagnos > parts) {
                                q.alert("", "Invalid Number of Sub Bags", true, 2999);
                                this.form.NoOfSubBag.value = 0;
                                return;
                            }
                        }
                    } else if (pieces > 1) {
                        q.hideField(this.form.EachSubBagParts);
                        this.form.EachSubBagParts.value = this.form.Parts.value;
                        q.showAndEnableField(this.form.EachSubBagPieces);
                    }

                    this.form.EachSubBagPieces.value = Math.floor(pieces / subbagnos);
                } else
                    this.form.EachSubBagPieces.value = 0;
            });
            this.form.EachSubBagPieces.changeSelect2(e => {
                if (this.form.NoOfSubBag.value != undefined) {
                    var subbagnos = this.form.NoOfSubBag.value;
                    var eachsubbagpieces = this.form.EachSubBagPieces.value;
                    var pieces = this.form.Pieces.value;

                    var piecespossible = pieces;
                    var piecesrequired = eachsubbagpieces * subbagnos;


                    if (piecesrequired > piecespossible) {
                        q.alert("", "Invalid Number of Sub Bags", true, 2999);
                        this.form.EachSubBagPieces.value = 0;
                        return;
                    }
                } else {
                    q.alert("", "Need to set Number of Sub Bags first", true, 2999);
                    this.form.EachSubBagPieces.value = 0;
                    return;
                }

            });
            this.form.EachSubBagParts.changeSelect2(e => {
                if (this.form.NoOfSubBag.value != undefined) {
                    var subbagnos = this.form.NoOfSubBag.value;
                    var eachsubbagparts = this.form.EachSubBagParts.value;
                    var parts = this.form.Parts.value;

                    var partspossible = parts;
                    var partsrequired = eachsubbagparts * subbagnos;


                    if (partsrequired > partspossible) {
                        q.alert("", "Invalid Number of Sub Bags", true, 2999);
                        this.form.EachSubBagParts.value = 0;
                        return;
                    }
                } else {
                    q.alert("", "Need to set Number of Sub Bags first", true, 2999);
                    this.form.EachSubBagParts.value = 0;
                    return;
                }

            });
        }


        protected inplaceSearchClick(e: any): void {
            if (!this.isViewMode()) {
                if (this.form.Details.getItems().length == 0) {
                    var grid = WIPMovementSelectGridForSplitting;
                    var filters: _Ext.SelectGridFilters = {
                        PartyId: 0,
                        SplitEmptyBag: this.splitEmptyBag,
                        SplitSingleItem: this.splitSingleItem,
                        AllowSplitParts: this.allowSplitParts
                    }

                    var pickerDialog = new _Ext.GridItemPickerDialog({
                        gridType: grid, multiple: false, title: "Select Work Order", GridFilters: filters
                    });

                    pickerDialog.onSuccess = (selectedItems: WIPMovementRow[]) => {

                        if (selectedItems.length > 0) {
                            this.form.BagNo.value = selectedItems[0].BagNo;
                            this.form.Parts.value = selectedItems[0].Parts == undefined ? 1 : selectedItems[0].Parts;

                            this.form.Weight.value = selectedItems[0].Parts;
                            this.form.Pieces.value = selectedItems[0].Pieces;
                            this.form.Weight.value = selectedItems[0].Weight;


                            let bomdetails: WIPTransactionRow[];
                            WIPTransactionService.MFGBOMList({ BagNo: this.form.BagNo.value }, response => bomdetails = response.Entities, { async: false });
                            var newbomdetails = [];
                            for (var i = 0; i < bomdetails.length; i++) {
                                var value = bomdetails[i];

                                var newbom: SplittingBOMRow = {
                                    AttributeId: value.AttributeId,
                                    ItemTypeId: value.ItemTypeId,
                                    CalcOnId: value.CalcOnId,
                                    BomProductId: value.ProductId,
                                    BagNo: value.BagNo,
                                    ProductId: value.ProductId,
                                    Pieces: value.Pieces,
                                    Line_No: value.Line_No,
                                    PureWeight: value.PureWeight,
                                    Purity: value.Purity == null ? 0 : value.Purity,
                                    Weight: value.Weight,
                                    RefTransId: value.TransId,
                                    RefVoucherId: value.VoucherTypeId,
                                    CompanyId: value.CompanyId,
                                    FinancialYearId: value.FinancialYearId,
                                    Lab: value.Lab,
                                    LotNo: value.LotNo,
                                    RefTransItemId: value.RefTransItemId
                                };
                                newbomdetails.push(newbom);

                            }
                            this.bagselected = selectedItems[0];
                            this.bomDetails = bomdetails;
                            //this.CalculateTotals();
                        }
                    }
                    pickerDialog.dialogOpen();
                }
                else
                    q.Alert("Not Allowed", "Party can not be changed while items are added", 2000, false);
            }
            else
                q.Alert("View Mode", "Can not make changes in view mode", 2000, false);
        }

        protected setSubBags() {
            var bag = this.bagselected;
            var noofbags = this.form.NoOfSubBag.value;
            var noofpieces = this.form.EachSubBagPieces.value;
            var itempieces = this.form.Pieces.value;
            var itemparts = this.form.Parts.value;
            var Parts = this.form.EachSubBagParts.value;
            this.form.Details.setData(bag, noofbags, noofpieces, itempieces, itemparts, Parts, this.bomDetails);
        }

        protected onDialogOpen() {
            super.onDialogOpen();
            var value = q.ToBool(TabAurous.GetConfigValue(1025));  
            this.splitEmptyBag = value; 

            value = q.ToBool(TabAurous.GetConfigValue(1026));  
            this.splitSingleItem = value;

            value = q.ToBool(TabAurous.GetConfigValue(1027));  
            this.allowSplitParts = value; 
        }

        protected getToolbarButtons(): Serenity.ToolButton[] {
            let btns = super.getToolbarButtons();
            var btnDelete = Q.first(btns, x => x.cssClass == "delete-button");
            var oldDeleteClick = btnDelete.onClick;
            btnDelete.onClick = e => { this.confirmBeforeDelete(oldDeleteClick, e); };


            //Edit Click Override
            var btnEdit = Q.first(btns, x => x.cssClass == "edit-button");
            var oldEditClick = btnEdit.onClick;
            btnEdit.onClick = e => { this.confirmBeforeEdit(oldEditClick, e); };

            ////Export PDF Button
            //btns.push(TabAurous.Common.ReportHelper.createToolButton({
            //    title: 'Invoice',
            //    cssClass: 'export-pdf-button',
            //    reportKey: 'Purchase.Approval',
            //    getParams: () => ({
            //        TransID: this.get_entityId()
            //    })
            //}));


            return btns;
        }
        // **** Validate Reference of Voucher in Stock Transaction Before Edit. ****
        private confirmBeforeEdit(oldEvt, e) {
            if (this.hasUpdatePermission) {
                let self = this;
                var refid = WIPMovementRow.getLookup().items.filter(x => x.RefTransId == parseInt(this.form.TransId.value) && x.RefVoucherId == this.form.VoucherTypeId.value)[0];
                if (refid != null) {
                    if (refid.PartyId != null || refid.PartyId > 0) {
                        q.Alert("Can not Edit!", "This Voucher has been used in transactions", 2500, false);
                        return;
                    }
                } else {
                    Serenity.EditorUtils.setReadonly(this.form.Details.element, false);
                    //this.form.Details.Editable();
                    if (!self.isEditMode())
                        return;
                    self.editClicked = true;

                    self.updateInterface();
                    self.updateTitle();

                }
            }
        }
        // **** Validate Reference of Voucher in Stock Transaction Before Delete. ****
        private confirmBeforeDelete(oldEvt, e) {
            let self = this;
            let refid: Stock.StockItemRow;
            Stock.StockItemService.CheckTransaction(
                { RefTransId: parseInt(this.form.TransId.value), RefVoucherId: this.form.VoucherTypeId.value },
                response => {
                    if (response.Entities != null && response.Entities.length > 0)
                        refid = response.Entities[0];
                }, { async: false }
            )
            if (refid != null) {
                if (refid.PartyId != null || refid.PartyId > 0) {
                    q.Alert("Can not Delete!", "This Voucher has been used in transactions", 2500, false);
                    return;
                }
            } else {

                Swal.fire({
                    title: 'Are you sure?',
                    text: "You won't be able to revert this!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, delete it!'
                }).then((result) => {
                    if (result.isConfirmed) {
                        SplittingService.Delete(
                            {
                                EntityId: this.entityId
                            }, response => {
                                Serenity.SubDialogHelper.triggerDataChange(self);
                                self.dialogClose();
                                window.setTimeout(() => //Q.notifySuccess(Q.text('Deleted successfully')), 0);
                                    Swal.fire({
                                        icon: 'success',
                                        title: 'Deleted!',
                                        text: 'Voucher Deleted',
                                        showConfirmButton: false,
                                        timer: 1500
                                    })
                                );
                            }
                        );
                    }
                })
            }
        }

    }
}